import { apiBase } from '@/utils/apiBase.utils';

export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  TIMEOUT: 30000, // 30 seconds
};

export const CHECK_IN_LOGS_API_ENDPOINTS = {
  CHECK_IN_LOGS_SEARCHING: `${apiBase()}/check-in-logs/searching`,
  CHECK_IN_LOGS_ID: `${apiBase()}/check-in-logs/:logId`,
  CHECK_IN_LOGS_THUMBNAIL: `${apiBase()}/check-in-logs/:logId/thumbnail`,
  CHECK_IN_LOGS: `${apiBase()}/check-in-logs`,
};

export const PROFILES_API_ENDPOINTS = {
  PROFILES: `${apiBase()}/profiles`,
  PROFILES_ID: `${apiBase()}/profiles/:profileId`,
  PROFILES_SEARCHING: `${apiBase()}/profiles/searching`,
  PROFILES_THUMBNAIL: `${apiBase()}/profiles/:profileId/thumbnail`,
  PROFILES_FACIAL_PHOTO: `${apiBase()}/profiles/:profileId/facial/:photoId`,
  PROFILES_PHOTO_CHUNKS: `${apiBase()}/profiles/photos/chunks`,
  PROFILES_PHOTO_CHUNKS_INDEX: `${apiBase()}/profiles/photos/:photoId/chunks/:chunkIndex`,
  PROFILES_FACIAL: `${apiBase()}/profiles/:profileId/facial`,
  PROFILES_EMPLOYEES_CURSOR: `${apiBase()}/profiles/employees/cursor`,
};

export const DEVICES_API_ENDPOINTS = {
  DEVICES_SERIAL: `${apiBase()}/devices/:serialNumber`,
  DEVICES_SEARCHING: `${apiBase()}/devices/searching`,
  DEVICES_CURSOR: `${apiBase()}/devices/cursor`,
};

export const ROLES_API_ENDPOINTS = {
  ROLES_ASSIGNMENTS_ID: `${apiBase()}/roles/assignments/:id`,
  ROLES_ASSIGNMENTS_SEARCHING: `${apiBase()}/roles/assignments/searching`,
  ROLES_CURSOR: `${apiBase()}/roles/cursor`,
  ROLES_ID: `${apiBase()}/roles/:id`,
};

export const AUTH_API_ENDPOINTS = {
  AUTH_LOGIN: `${apiBase()}/auth/login`,
  AUTH_LOGOUT: `${apiBase()}/auth/logout`,
  AUTH_SEND_OTP: `${apiBase()}/auth/email/:email/send/otp`,
  AUTH_RESEND_OTP: `${apiBase()}/auth/email/:email/resend/otp`,
  AUTH_VERIFY_OTP: `${apiBase()}/auth/email/:email/verify/otp/:otp/:scope`,
  AUTH_PROFILE: `${apiBase()}/auth/profile`,
};

export const EXCLUDED_ALERT_ERROR_ENDPOINTS = [
  AUTH_API_ENDPOINTS.AUTH_LOGIN,
  AUTH_API_ENDPOINTS.AUTH_SEND_OTP,
  AUTH_API_ENDPOINTS.AUTH_RESEND_OTP,
  AUTH_API_ENDPOINTS.AUTH_VERIFY_OTP,
  PROFILES_API_ENDPOINTS.PROFILES,
  PROFILES_API_ENDPOINTS.PROFILES_ID,
  DEVICES_API_ENDPOINTS.DEVICES_SERIAL,
  ROLES_API_ENDPOINTS.ROLES_ASSIGNMENTS_ID,
  ROLES_API_ENDPOINTS.ROLES_ASSIGNMENTS_ID.replace(':id', ''),
];

export const EXCLUDED_ALERT_STATUS_CODES = [400, 401];
